import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import { PermissionGrantResponse } from '../../Interfaces/api/backoffice/rbac.interface';

export class PermissionGrant {
  id = 0;
  name: string | null = null;
  is_scopeable = false;
  scope: string | null = null;

  constructor(data: Partial<PermissionGrantResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.name || String(this.id);
  }

  get scopeLabel(): string {
    return this.scope || VALUE_UNRESOLVED;
  }
}
